import React from 'react'
import Employee from './Employee'

const EmployeeLayout = () => {
  return (
    <div className="container">
      <Employee />
    </div>
  )
}

export default EmployeeLayout
